import React from 'react';

const TimelineFilters = ({ appliedFilters, managerOptions, purposeTypes, removeFilter, clearFilters }) => {
    if (!appliedFilters.startDate && !appliedFilters.endDate && !appliedFilters.salesManagerUUID && !appliedFilters.purposeOfVisit) {
        return null;
    }

    return (
        <div className="filter-section main-card p-2 mb-2">
            <div className="active-filters mt-0 pt-0 border-0">
                Active Filters:
                {(appliedFilters.startDate || appliedFilters.endDate) && (
                    <div className="filter-tag">
                        <i className="mdi mdi-calendar"></i>
                        {appliedFilters.startDate || 'Start'} - {appliedFilters.endDate || 'End'}
                        <button onClick={() => removeFilter('date')}><i className="mdi mdi-close"></i></button>
                    </div>
                )}
                {appliedFilters.salesManagerUUID && (
                    <div className="filter-tag">
                        <i className="mdi mdi-account"></i>
                        {managerOptions.find(m => m.value === appliedFilters.salesManagerUUID)?.label || appliedFilters.salesManagerUUID}
                        <button onClick={() => removeFilter('manager')}><i className="mdi mdi-close"></i></button>
                    </div>
                )}
                {appliedFilters.purposeOfVisit && (
                    <div className="filter-tag">
                        <i className="mdi mdi-flag"></i>
                        {purposeTypes[appliedFilters.purposeOfVisit]?.label || appliedFilters.purposeOfVisit}
                        <button onClick={() => removeFilter('purpose')}><i className="mdi mdi-close"></i></button>
                    </div>
                )}
                <button className="btn btn-link btn-sm text-danger text-decoration-none" onClick={clearFilters}>
                    Clear All
                </button>
            </div>
        </div>
    );
};

export default TimelineFilters;
